import React from 'react';
import { bool, func, oneOf, shape } from 'prop-types';
import { EvaluateFlag } from 'common/FeatureFlags/Flag';
import Products from '../../../edit/products/Products';
import ProductsAccordion from '../../../components/ProductsAccordion';
import ProductsTabContent from './ProductsTabContent';

const ProductsTab = ({ customerAuth, setCustomerAuth, isEditMode, mode }) => {
  const productsTabFlag = EvaluateFlag(
    process.env.REACT_APP_LD_CUSTOMER_AUTHORIZATION_PRODUCTS_TAB
  );

  if (productsTabFlag) {
    return (
      <ProductsTabContent
        customerAuth={customerAuth}
        mode={mode}
        setCustomerAuth={setCustomerAuth}
      />
    );
  }

  return (
    <div>
      {isEditMode ? (
        <Products info={customerAuth} setInfo={setCustomerAuth} />
      ) : (
        <ProductsAccordion
          authorizationType={customerAuth.authorizationType}
          defaultExpanded
          products={customerAuth.products || []}
        />
      )}
    </div>
  );
};
ProductsTab.propTypes = {
  customerAuth: shape({}).isRequired,
  isEditMode: bool.isRequired,
  mode: oneOf(['edit', 'view']),
  setCustomerAuth: func.isRequired,
};
ProductsTab.defaultProps = {
  mode: 'edit',
};
export default ProductsTab;
